import { render, staticRenderFns } from "./pdf-viewer.vue?vue&type=template&id=aafeb726&scoped=true&"
import script from "./pdf-viewer.vue?vue&type=script&lang=js&"
export * from "./pdf-viewer.vue?vue&type=script&lang=js&"
import style0 from "./pdf-viewer.vue?vue&type=style&index=0&id=aafeb726&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aafeb726",
  null
  
)

export default component.exports